var AppointmentsReviewDataTestId = /* @__PURE__ */ ((AppointmentsReviewDataTestId2) => {
  AppointmentsReviewDataTestId2["APPOINTMENT_REVIEW_NPS_SECTION"] = "apointment-review--nps-section";
  AppointmentsReviewDataTestId2["APPOINTMENT_REVIEW_PROFESSIONAL_SECTION"] = "appointment-review--professional-section";
  AppointmentsReviewDataTestId2["APPOINTMENT_REVIEW_LOCATION_SECTION"] = "appointment-review--location-section";
  AppointmentsReviewDataTestId2["APPOINTMENT_REVIEW_SUCCESS_MODAL"] = "appointment-review--success-modal";
  AppointmentsReviewDataTestId2["APPOINTMENT_REVIEW_REJECT_REVIEW_MODAL"] = "appointment-review--reject-review-modal";
  AppointmentsReviewDataTestId2["APPOINTMENT_REVIEW_SUBMIT_BUTTON"] = "appointment-review--submit-button";
  AppointmentsReviewDataTestId2["APPOINTMENT_REVIEW_NPS_INPUT_GROUP"] = "appointment-review--nps-input-group";
  AppointmentsReviewDataTestId2["APPOINTMENT_REVIEW_LOCATION_STAR_INPUT_GROUP"] = "apointment-review--location-star-input-group";
  AppointmentsReviewDataTestId2["APPOINTMENT_REVIEW_PROFESSIONAL_STAR_INPUT_GROUP"] = "apointment-review--professional-star-input-group";
  AppointmentsReviewDataTestId2["APPOINTMENT_REVIEW_DISABLED_OR_MODERATED_SECTION"] = "appointment-review--disabled-or-moderated-section";
  return AppointmentsReviewDataTestId2;
})(AppointmentsReviewDataTestId || {});
export {
  AppointmentsReviewDataTestId
};
